module.exports = __webpack_public_path__ + "static/media/create.18918a56.svg";